import React from 'react';
import WebsiteBuilderAppIcon from 'housecall-ui/dist/IconsAndImages/AppIcons/WebsiteBuilderAppIcon';

import Spacer20 from '../../../Misc/Spacer20.js';

const WebsitesStrategy = {
  previewInfo: {
    name: 'Websites by Housecall Pro',
    iconSvg: <WebsiteBuilderAppIcon size="xlarge" />,
  },
  headerInfo: {
    name: 'Websites by Housecall Pro',
    category: 'Built to get you more jobs',
    details: (
      <div>
        Websites by Housecall Pro is the ultimate solution for busy business owners who want a stunning website without
        the hassle of building one themselves or paying thousands of dollars to a third party agency. You&apos;ll get a
        modern, professional, and SEO optimized site with everything you need, without having to lift a finger.
        <Spacer20 />
        Gone are the days of struggling to set up, edit, and maintain your website. Our team of experts will build you a
        robust website that integrates seamlessly with your Housecall Pro account. Your website will become a
        one-stop-shop for your customers, where they can chat with you online, book appointments directly onto your
        calendar, learn about your services, and read reviews.
        <Spacer20 />
        Your online presence is the front door to your business. With Websites by Housecall Pro, we can equip you with a
        legitimate website experience that will help increase lead conversion. Show your customers who you are and why
        they should choose you for their home service needs. Try Websites by Housecall Pro today and take your online
        presence to the next level!
      </div>
    ),
    iconSvg: <WebsiteBuilderAppIcon size="xlarge" />,
  },
  price: {
    showBetaButton: false,
    hideToggle: true,
    hideCard: true,
  },
  supportContacts: [{ type: 'Email', contact: 'website.team@housecallpro.com' }],
};

export default WebsitesStrategy;
